export default "__VITE_ASSET__BTXOEb8i__"